import styled from "styled-components";

import { ComposableMap } from "react-simple-maps";

export const CountryCoverageMapContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const CountryCoverageMapMediaSurface = styled.div.attrs({
  className:
    "overflow-hidden rounded-[30px] border border-transparent bg-[rgba(17,22,29,0.98)] p-3",
})``;

export const CountryCoverageMapMediaSurfaceSecondary = styled.div.attrs({
  className:
    "relative overflow-hidden rounded-[24px] border border-transparent bg-[rgba(9,18,29,0.24)]",
})``;

export const CountryCoverageMapSectionBody = styled.div.attrs({
  className:
    "pointer-events-none absolute left-5 top-5 z-10 rounded-[22px] border border-transparent bg-[rgba(12,24,36,0.72)] px-4 py-3 text-white backdrop-blur-md",
})``;

export const CountryCoverageMapEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.32em] text-white/80",
})``;

export const CountryCoverageMapBodyText = styled.p.attrs({
  className: "mt-2 text-2xl font-semibold leading-none",
})``;

export const CountryCoverageMapTextBlock = styled.p.attrs({
  className: "mt-2 text-sm text-white/80",
})``;

export const CountryCoverageMapMapCanvas = styled(ComposableMap).attrs({
  className: "h-auto w-full",
})``;

export const CountryCoverageMapMapRegionGroup = styled.g.attrs({ className: "cursor-pointer" })``;

export const CountryCoverageMapGridLayout = styled.div.attrs({
  className: "grid gap-4 lg:grid-cols-[1.2fr_0.8fr]",
})``;

export const CountryCoverageMapSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const CountryCoverageMapInfoRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-2",
})``;

export const CountryCoverageMapMetaText = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const CountryCoverageMapEyebrowTextSecondary = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.22em] text-[var(--brand-muted)]",
})``;

export const CountryCoverageMapBodyTextSecondary = styled.p.attrs({
  className: "mt-2 text-sm leading-6 text-[var(--brand-ink)]",
})``;

export const CountryCoverageMapGridLayoutSecondary = styled.div.attrs({
  className: "mt-4 grid gap-3 sm:grid-cols-2",
})``;

export const CountryCoverageMapPanelCard = styled.div.attrs({
  className: "rounded-2xl border border-transparent bg-[rgba(255,255,255,0.04)] px-4 py-3",
})``;

export const CountryCoverageMapEyebrowTextTertiary = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const CountryCoverageMapTitleText = styled.p.attrs({
  className: "mt-1 text-xl font-semibold text-[var(--brand-ink)]",
})``;

export const CountryCoverageMapMetaTextSecondary = styled.p.attrs({
  className: "mt-3 text-sm text-[var(--brand-muted)]",
})``;
